import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-po-load-plan',
  templateUrl: './po-load-plan.component.html',
  styleUrls: ['./po-load-plan.component.css']
})
export class PoLoadPlanComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3674))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_poloadplan_grid')
                .setLoadDataFunction({
                    method: 3675,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                Promise.all([
                    this.loadStockPlaces()
                ]).then(() => {
                    this.loadGrid();
                    Promise.resolve();
                });
                break;
            case 'stockplace_id':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    public onDateRangeChanged() {
        if (!this.setting) return;

        this.loadGrid();
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        
        return Promise.all([
            this.loadStockPlaces()
        ]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    show_setting: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
}
